module.exports = __webpack_public_path__ + "assets/560b41995e412ae963fe5ff15e6d9e81.mp3";